export default __webpack_public_path__ + "static/logo-cattolica-angel-only-16-9-62ac35f88b083f85fd301fa63f08d0ee.png";